import React, {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from '../FatalError/error.module.scss';
import Footer from '../../sharedUI/Footer/Footer';
import PrimaryButton from '../../sharedUI/button/PrimaryButton';
import {trackAdobeDncPages} from "../../../shared/AdobeUtility";
//import { useAppContent } from "../../../shared/AppContent";
import { funcUpdateCurrentAppState } from "../../../store/actions/AppStateActions";
import { RedirectToHelpScreen, isRestrictedCustomerwithAppNo } from "../../../shared/utility";
import { getPartnerName } from "../../../shared/PartnerUtility";

export const NetOffline = () => {
    const currentAppState = useSelector((state) => state.AppState);
    const userDetail = useSelector((state) => state.User.UserDetail);
    //const { technicalErrorContent } = useAppContent();
    const dispatch = useDispatch();
    const updateState = (currentAction, screenName) => dispatch(funcUpdateCurrentAppState(currentAction, screenName));
    const ckycData = useSelector((state) => state.SSL.ckycData);

    const funcHandleClick = () => {
        const partner = getPartnerName();
        if (partner) {
            RedirectToHelpScreen("", currentAppState, "", "", ckycData);
        }
        else {
        if (isRestrictedCustomerwithAppNo(currentAppState?.cardListDetails?.uniqueIdentifier, ckycData)) {
            window.location.href = window.location.origin;
        }
        else if (currentAppState?.cardListDetails?.uniqueIdentifier) {
            window.location.pathname = `/${process.env.REACT_APP_NAME}/${currentAppState?.cardListDetails?.uniqueIdentifier}`
        } else {
            window.location.reload(true);
        }
        }
    }   
    useEffect(() => {
        let additionalArr={wipStepName:"net_offline"};
        trackAdobeDncPages("error",currentAppState,"errorPage",userDetail,additionalArr);
        updateState("FatalError", "errorScreen");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.errorContainer}>
            <div className={classes.contentContainer}>
                <div className={`${classes.textContainer} ${classes.maintainerContainer}`}>
                    <h1 className={classes.errorText1}> Check Internet Connection </h1>
                    <p className={classes.errorText2}>No Internet Connection Available</p>
                    <br />
                    <p className={classes.errorText2}>Looks like your are currently offline. Please check if your internet connection is available</p>
                    <PrimaryButton
                        // label={technicalErrorContent?.button ? technicalErrorContent?.button : 'Go to homepage'}
                        label={'Go to homepage'}
                        dataTestid="submit-button"
                        ext={"png"}
                        renditions={["2x"]}
                        handleClick={() => funcHandleClick()}
                        className={classes.button}
                        appState={currentAppState}
                    />
                </div>
            </div>
            <Footer className={classes.footer} />
        </div>
    );

}
export default NetOffline;
